import { useNotifications } from '@doveit/bricks';
import React from 'react';
import { Contact } from '../../../providers/api/dtos/contact';
import ContactForm, { ContactFormModel } from '../../components/contact-form/ContactForm';
import { contactFormModelToContact, contactToContactFormModel } from '../../utils/mappers';
import createOrUpdateContact from '../../utils/createOrUpdateContact';

export interface UpdateContactProps {
  contact: Contact,
  onSuccess?: (updatedContact: Contact) => void,
  submitLabel?: string,
}

export const UPSERT_CONTACT_SUCCESS_MESSAGE = 'Il contatto è stato salvato';
export const UPSERT_CONTACT_ERROR_MESSAGE = 'Non è stato possibile salvare il contatto';

const UpdateContact: React.FC<UpdateContactProps> = ({
  contact,
  onSuccess,
  submitLabel,
}) => {
  const { addSuccess, addError } = useNotifications();
  const [isSaving, setIsSaving] = React.useState(false);

  const initialValues = React.useMemo(
    () => contactToContactFormModel(contact),
    [contact],
  );

  const onSubmit = React.useCallback(async (values: ContactFormModel) => {
    setIsSaving(true);

    try {
      const updatedContact = await createOrUpdateContact(contactFormModelToContact(values), contact);

      setIsSaving(false);
      addSuccess(UPSERT_CONTACT_SUCCESS_MESSAGE);

      if (onSuccess) {
        onSuccess(updatedContact);
      }
    } catch (error) {
      setIsSaving(false);
      addError(UPSERT_CONTACT_ERROR_MESSAGE);
    }
  }, [contact, addError, addSuccess, onSuccess]);

  return (
    <ContactForm
      loading={isSaving}
      initialValues={initialValues}
      oldInitialValues={initialValues}
      onSubmit={onSubmit}
      submitLabel={submitLabel}
      showIdentityDocument
      showBirthData
      showCitizenship
    />
  );
};

export default UpdateContact;
